import querystring from 'querystring'
import { IS_WECHAT_APP } from '../utils/device'
import store from '../store'

const WECHAT_OPENID_SERVER = 'https://api.wanfangche.com/community/public/wechat/redirect?redirect_url='
const OPEN_ID_KEY = 'WFC_WECHAT_OPENID'

export class WechatFactory {
  // 尝试获取openid
  // 业务中如果需要获取微信opneid
  // 当需要使用openid时, 调用getToken方法
  static tryInitOpenId () {
    if (!IS_WECHAT_APP) return
    const openid = WechatFactory.getOpenidFromLocal()
    // 本地缓存中没有的话尝试发起
    if (!openid) {
      return WechatFactory.initOpenId()
    }
    // 存储到store
    return WechatFactory.setOpenid2Store(openid)
  }

  // 初始化微信OpenId
  static initOpenId () {
    // 1. 当前url中取出query
    // 2. query 转 object
    // 3. 提取 openid, openid_state参数
    // 4. 如果有 openid 直接存
    // 5. 如果没有openid, 也没有 openid_state 参数，跳转的方式去取
    // 6. 取之前地址中加上 openid_state=1, 防止无限回跳
    const currentURL = window.location.href
    const [url, queryStr] = currentURL.split('?')
    const query = querystring.parse(queryStr)
    const { openid, openid_state } = query

    if (!openid_state) {
      const newQuery = {
        ...query,
        openid_state: 1
      }
      const newQueryStr = querystring.stringify(newQuery)
      const newUrl = encodeURIComponent(`${url}?${newQueryStr}`)
      const target = `${WECHAT_OPENID_SERVER}${newUrl}`
      // window.location.href = target
      window.location.replace(target)
      return
    }
    WechatFactory.saveOpenId(openid)
  }

  // 是否已经有openid了
  static hasOpenId () {
    return false
  }

  // 获取当前openid
  static getOpenid () {
    return store.state.openid
  }

  // 本地缓存中取openid
  static getOpenidFromLocal () {
    return window.localStorage.getItem(OPEN_ID_KEY)
  }

  // 存储openID
  static saveOpenId (openid = '') {
    window.localStorage.setItem(OPEN_ID_KEY, openid)
    WechatFactory.setStoreOpenid(openid)
    return openid
  }

  // 设置store中的openid
  static setOpenid2Store (openid = '') {
    store.dispatch('saveOpenid', { openid })
  }

  /* eslint-disable */
  static callJSAPIPay (data) {
    function onBridgeReady () {
      WeixinJSBridge.invoke('getBrandWCPayRequest', data, function (res) {
        if (res.err_msg === 'get_brand_wcpay_request:ok') {
        // 使用以上方式判断前端返回,微信团队郑重提示：
        // res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
        }
      })
    }
    if (typeof WeixinJSBridge === 'undefined') {
      if (document.addEventListener) {
        document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false)
      } else if (document.attachEvent) {
        document.attachEvent('WeixinJSBridgeReady', onBridgeReady)
        document.attachEvent('onWeixinJSBridgeReady', onBridgeReady)
      }
    } else {
      onBridgeReady()
    }
  }
}

export default WechatFactory
